




























































import { Vue, Component } from 'vue-property-decorator';
import { Button } from 'vant';
import Uploader from '@/components/Uploader.vue';
import AnyUploader from '@/components/next/AnyUploader.vue';
import Prism from 'prismjs';
// import SyPlayer from '@/components/SyPlayer.vue';
import XGplayer from '@/components/XGplayer.vue';
import SyAudioPlayer from '@/components/next/SyAudioPlayer.vue';
import { FileType } from '@/common/ts/enum';

Vue.use(Button);

@Component({
  components: {
    Uploader,
    XGplayer,
    AnyUploader,
    SyAudioPlayer,
  },
})
export default class MediaUpload extends Vue {
  presetFilesImages = [
    {
      cover:
        'https://image2.cqcb.com/d/file/topics/activity/2020-05-12/Z1Crhk36-640956.jpg?x-oss-process=image/resize,p_20',
      path:
        'https://image2.cqcb.com/d/file/topics/activity/2020-05-12/Z1Crhk36-640956.jpg?x-oss-process=image/resize,p_20',
      type: FileType.Image,
    },
    {
      cover:
        'https://image2.cqcb.com/d/file/topics/activity/2020-05-12/YBLpDtHa-56276435_p0.jpg?x-oss-process=image/resize,p_20',
      path:
        'https://image2.cqcb.com/d/file/topics/activity/2020-05-12/YBLpDtHa-56276435_p0.jpg?x-oss-process=image/resize,p_20',
      type: FileType.Image,
    },
  ];
  presetFilesVideos: any = [];
  created() {
    setTimeout(() => {
      this.presetFilesVideos = [
        {
          cover:
            'https://image2.cqcb.com/d/file/headline/2020-05-12/f52107aa2c1fb69329a23293360e64a1.jpg?x-oss-process=image/resize,p_20',
          path:
            'https://recordcdn.quklive.com/upload/vod/user1462960877450854/1589269151529948/18/video.m3u8',
          type: FileType.Video,
        },
      ];
    }, 3000);
  }
  mounted() {
    Prism.highlightAll();
  }
  onMediaUpload(type: number) {
    if (type === 0) {
      (this.$refs.uploaderImage as Uploader).uploadToOss().then((res) => {
        console.log('img urls result:', res);
      });
    } else if (type === 1) {
      (this.$refs.uploaderVideo as Uploader).uploadToOss().then((res) => {
        console.log('video url result:', res);
      });
    }
  }
  onMediaUploadWithPresetFiles(type: number) {
    if (type === 0) {
      (this.$refs.uploaderImageWithPreset as Uploader)
        .uploadToOss()
        .then((res) => {
          console.log('img urls result:', res);
        });
    } else if (type === 1) {
      (this.$refs.uploaderVideoWithPreset as Uploader)
        .uploadToOss()
        .then((res) => {
          console.log('video url result:', res);
        });
    }
  }
  async onImageUploadWithCrop() {
    const ret = await (this.$refs
      .uploaderImageWithCrop as Uploader).uploadToOss();
    console.log('img after crop urls are:', ret);
  }
}
